import { Card, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import PropTypes from "prop-types";

const ComponentCard = ({ children, title, subtitle, action }) => {
  return (
    <Card className="custom-card">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center border-bottom px-4 py-3 custom-card-head">
        <CardTitle tag="h4" className="mb-0">
          {title}
        </CardTitle>

        {/* Right Side Button / Action */}
        {action && <div>{action}</div>}
      </div>

      <CardBody className="p-4">
        {subtitle && (
          <CardSubtitle className="text-muted mb-3">
            {subtitle}
          </CardSubtitle>
        )}
        <div>{children}</div>
      </CardBody>
    </Card>
  );
};

ComponentCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.node,
  action: PropTypes.node, // ✅ new prop
};

export default ComponentCard;